import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Switch } from "./ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

function nowLocal() {
    const d = new Date(Date.now() + 330 * 60000);
    return d.toISOString().slice(0, 16);
}

function CollectorSelect({ value, onChange, me }) {
    const { user } = useAuth();
    const [users, setUsers] = useState([]);
    useEffect(() => {
        api.get("/users").then((r) => setUsers((r.data || []).filter(
            (u) => u.username !== user.username && ["employee", "admin"].includes(u.role) && u.active !== false))).catch(() => {});
    }, [user.username]);
    const options = [{ username: user.username, name: user.name, role: user.role }, ...users];
    return (
        <div>
            <Label>Collected By</Label>
            <Select value={value || me} onValueChange={onChange}>
                <SelectTrigger className="mt-1.5" data-testid="backdate-collected-by"><SelectValue /></SelectTrigger>
                <SelectContent>
                    {options.map((u) => (
                        <SelectItem key={u.username} value={u.username}>{u.name || u.username} ({u.role})</SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}

/** Admin-only backdated entry fields. `timeOnly` = investment (date comes from start date). */
export function BackdateFields({ value, onChange, timeOnly = false }) {
    const { user } = useAuth();
    if (user?.role !== "admin") return null;
    const set = (k, v) => onChange({ ...value, [k]: v });
    if (timeOnly) {
        return (
            <div className="grid grid-cols-2 gap-3" data-testid="backdate-fields">
                <div>
                    <Label>Collection time (IST)</Label>
                    <Input type="time" className="mt-1.5" value={value.collection_time || ""} data-testid="backdate-time"
                        onChange={(e) => set("collection_time", e.target.value)} />
                </div>
                <CollectorSelect value={value.collected_by} me={user.username} onChange={(v) => set("collected_by", v)} />
            </div>
        );
    }
    const on = !!value.enabled;
    return (
        <div className="rounded-xl border border-slate-200 p-3 space-y-3" data-testid="backdate-fields">
            <label className="flex items-center justify-between text-sm font-medium text-slate-700">
                Backdated entry (Admin)
                <Switch checked={on} data-testid="backdate-toggle"
                    onCheckedChange={(c) => onChange(c ? { enabled: true, collection_datetime: nowLocal(), collected_by: user.username } : {})} />
            </label>
            {on && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div>
                        <Label>Collection date & time (IST)</Label>
                        <Input type="datetime-local" className="mt-1.5" max={nowLocal()} value={value.collection_datetime || ""}
                            data-testid="backdate-datetime" onChange={(e) => set("collection_datetime", e.target.value)} />
                    </div>
                    <CollectorSelect value={value.collected_by} me={user.username} onChange={(v) => set("collected_by", v)} />
                </div>
            )}
        </div>
    );
}

export function backdatePayload(v) {
    if (!v?.enabled) return {};
    return { collection_datetime: v.collection_datetime || null, collected_by: v.collected_by || null };
}
